import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { disableSFTPNetworkElement } from '@api/networkElements';

import { IId } from '@interfaces/common/common';
import { INetworkElement } from '@interfaces/networkElements/networkElements';

import { ESnackbarTypes } from '@enums/common';

import { NETWORK_ELEMENTS_DISABLE_SFTP } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

import useInvalidateNetworkElements from './useInvalidateNetworkElements';

interface IUseMutateNetworkElementsDisableSFTPReturned {
	handleDisableSFTP: (dto: IId) => void;
	isLoadingDisableSFTP: boolean;
}

const useMutateNetworkElementsDisableSFTP = (
	handleCloseModal: () => void,
): IUseMutateNetworkElementsDisableSFTPReturned => {
	const invalidateNetworkElements = useInvalidateNetworkElements();
	const dispatch = useAppDispatch();

	const {
		mutateAsync,
		isLoading,
	} = useMutation<IId>({
		mutationKey: [NETWORK_ELEMENTS_DISABLE_SFTP],
		mutationFn: disableSFTPNetworkElement,
		onSuccess: (data: INetworkElement) => {
			handleCloseModal();

			dispatch(setSnackbar({
				message: responseMessages.disableNetworkElementsSFTP(data?.name),
				type: ESnackbarTypes.success,
			}));

			return invalidateNetworkElements();
		},
	});

	return {
		handleDisableSFTP: mutateAsync,
		isLoadingDisableSFTP: isLoading,
	};
};

export default useMutateNetworkElementsDisableSFTP;
